import { render } from "./BlForm.vue?vue&type=template&id=fb5c5ef4"
import script from "./BlForm.vue?vue&type=script&lang=js"
export * from "./BlForm.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__